import type { ReactNode } from "react"
import type { FieldError } from "react-hook-form"

// Accept FieldError or array errors (from array fields like imageIds)
type FormError = FieldError | { message?: string } | undefined

interface FormFieldProps {
  label: string
  required?: boolean
  error?: FormError
  hint?: string
  children: ReactNode
  className?: string
}

/**
 * Wrapper component for form fields providing consistent label, error, and hint styling.
 */
export function FormField({
  label,
  required = false,
  error,
  hint,
  children,
  className = "",
}: FormFieldProps) {
  // Extract message from error (handles both FieldError and array errors)
  const errorMessage = error && "message" in error ? error.message : undefined

  return (
    <div className={className}>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
        {required && <span className="text-red-500 ml-0.5">*</span>}
      </label>
      {children}
      {errorMessage && <p className="mt-1 text-sm text-red-500">{errorMessage}</p>}
      {hint && !errorMessage && <p className="mt-1 text-xs text-gray-500">{hint}</p>}
    </div>
  )
}
